<section class="sorting" [formGroup]="fieldForm">
  <div
    class="selectSort"
    *ngIf="currentDataFields && currentDataFields.length > 0"
  >
    <div class="left">
      <mat-form-field appearance="fill" style="width: 95%">
        <mat-select
          formControlName="selectItem"
          [placeholder]="choosePlaceholder()"
          floatPlaceholder="never"
          (selectionChange)="addSort()"
        >
          <mat-option
            [value]="item.id"
            *ngFor="let item of currentDataFields"
            [ngStyle]="{
              display: isInSorts(item.id) ? 'none' : 'block'
            }"
          >
            {{ item.name }}
          </mat-option>
        </mat-select></mat-form-field
      >
    </div>
  </div>
  <span class="applied">APPLIED SORTS </span>
  <div class="fieldArea" [formGroup]="fieldForm">
    <div cdkDropList class="sort-list" (cdkDropListDropped)="drop($event)">
      <ng-container
        formArrayName="sortby"
        *ngFor="let item of sortlist.controls; let i = index"
      >
        <div cdkDragBoundary=".sort-list" class="reportField-box" cdkDrag>
          <div class="reorder-placeholder" *cdkDragPlaceholder></div>
          <div class="canvasFields" id="sort-{{ i }}" [formGroupName]="i">
            <div class="far-left">
              <fa-icon
                [icon]="faGripDotsVertical"
                class="grip"
                cdkDragHandle
              ></fa-icon>
            </div>
            <div class="left">
              <fa-icon
                [icon]="faArrowDownAZ"
                *ngIf="item.value.sort == ascending"
                (click)="changeSortDirection(i, decending)"
                matTooltip="Click to Sort Z-A"
                matTooltipPosition="above"
              ></fa-icon>
              <fa-icon
                [icon]="faArrowUpZA"
                *ngIf="item.value.sort == decending"
                (click)="changeSortDirection(i, ascending)"
                matTooltip="Click to Sort A-Z"
                matTooltipPosition="above"
              ></fa-icon>
            </div>
            <div class="right">
              <div
                class="title"
                *ngIf="item.value.sort == decending"
                (click)="changeSortDirection(i, ascending)"
                matTooltip="Click to change sort direction"
                matTooltipPosition="above"
              >
                {{ getName(i) }}
              </div>
              <div
                class="title"
                *ngIf="item.value.sort == ascending"
                (click)="changeSortDirection(i, decending)"
                matTooltip="Click to change sort direction"
                matTooltipPosition="above"
              >
                {{ getName(i) }}
              </div>
            </div>
            <div class="far-right">
              <fa-icon
                [icon]="faTrash"
                (click)="removeDataField($event, i)"
              ></fa-icon>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
